import { Edit05 } from "@untitledui/icons";
import { TextArea } from "@/components/base/textarea/textarea";
import { FieldGroup } from "./FieldGroup";
import type { CustomRiskRequestForm } from "./RequestCustomRiskModal";

type Props = {
  form: CustomRiskRequestForm;
  onChange: (patch: Partial<CustomRiskRequestForm>) => void;
};

export function NotesStep({ form, onChange }: Props) {
  return (
    <div className="flex gap-8">
      <div className="w-48 shrink-0 flex flex-col gap-3">
        <div className="bg-indigo-50 rounded-lg p-2 w-fit">
          <Edit05 className="size-5 text-indigo-700" />
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-sm font-semibold text-primary">Final notes</p>
          <p className="text-sm text-tertiary">
            Anything else that'll help us build this faster. Urgency, regulatory context, links to compliance docs.
          </p>
        </div>
      </div>

      <div className="flex flex-1 flex-col">
        <FieldGroup
          label="Anything else we should know?"
          description="Optional. Urgency, regulatory context, links to compliance docs."
        >
          <TextArea
            aria-label="Anything else we should know?"
            placeholder=""
            value={form.notes.extra ?? ""}
            onChange={(v) => onChange({ notes: { extra: v || undefined } })}
            rows={6}
          />
        </FieldGroup>
      </div>
    </div>
  );
}
